﻿
var contextExtensions = new Map();
function getCookie(cookieName) {
    let cookie = {};
    document.cookie.split(';').forEach(function(el) {
        let [key,value] = el.split('=');
        cookie[key.trim()] = value;
    })
    return cookie[cookieName];
}

function generateGUID() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        var r = Math.random() * 16 | 0,
            v = c === 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
    });
}

function UBTWorkerProcess(verbtype, activityname, extensions, resultObject, saveStatementCallback, UBTConstants,userID, role) {    
        try {
            var IsSimulationRealLife = false;
            if (!saveStatementCallback)
                saveStatementCallback = null;

            if (!resultObject)
                resultObject = null;

            var instance = new ATITinCan();

            instance.tpSourceSystem = UBTConstants.tpSourceSystem;
            instance.applicationId = UBTConstants.applicationId;
            instance.oAuthApplicationId = UBTConstants.oAuthApplicationId;
            instance.statementversion = UBTConstants.statementVersion;
            instance.environment(UBTConstants.Environment);
            contextExtensions.clear();

            if (extensions != null) {
                extensions.forEach(function (value, key, map) {
                    contextExtensions.set(key, value);                
                });
            }
            
            var SessionKey = getCookie(UBTConstants.XSRFToken);                        
            var actor = role;            
            var brandName = UBTConstants.tpSourceSystem;  
            var appName = UBTConstants.appName;  
            var requestId = generateGUID();
            var locationType = UBTConstants.locationType;

            var result = null;

            if (resultObject != null) {
                //resultobject
                var ResultObject = resultObject.split("~");
                var score = parseFloat(ResultObject[0]);
                var raw = parseFloat((score).toFixed(1));
                var StatusID = ResultObject[1];
                var TimeSpent = ResultObject[2];
                var a1 = TimeSpan();
                var duration = a1.duration(TimeSpent * 1000);
                var success = false;
                var completion = false;
                if (StatusID == 31) {
                    success = true;
                    completion = true;
                }

                if (IsSimulationRealLife)
                    result = instance.createTincanResult(success, completion, "", duration, 0, raw, 0, 0, null);
                else
                    result = instance.createTincanResult(success, completion, "", duration, 0, raw, 0, 100, null);
            }
            instance.sendTinCanEvent(
                actor,
               verbtype,
               activityname,
               SessionKey,
               userID,
               window.location.pathname,
               locationType,
               contextExtensions,
               result,
               brandName,
               appName,
               requestId, saveStatementCallback
            );
        }
        catch (err) {
            //console.log(err);
        }
}

if (typeof module !== 'undefined' && module.exports) {
    module.exports = { generateGUID };
}